<script>
    import DateTimePicker from "../../Common/DateTimePicker.svelte";
    import BlockGlobal from "./BlockGlobal.svelte";
    import {getCollapseClass} from '../../Common/tools';
    import {M} from "../../external";

    export let data, isCollapsable = false, isCollapsed = false;

    function change(e) {
        data = Object.assign({}, data, {endDate: e});
    }

    function toggleCollapse() {
        if (isCollapsable) {
            isCollapsed = !isCollapsed;
        }
    }
</script>
<div class="col20 f-left t-center mb-25 mt-15" on:click={toggleCollapse}>
    <h4 class="t-left {getCollapseClass(isCollapsable, isCollapsed)}">
        {M.COUNTDOWN}
    </h4>
</div>
{#if !isCollapsed}
    <DateTimePicker onChange={change} bind:value={data.endDate} readonly={true}/>
    <div class="popup-input-wrapper input-slider-wrapper mt-5">
        <h5 class="inline">{M.THEME}</h5>
        <select bind:value={data.theme}>
            <option value="light">{M.LIGHT}</option>
            <option value="dark">{M.DARK}</option>
        </select>
    </div>
{/if}
<BlockGlobal bind:data={data} isCollapsable={true} isCollapsed={true}/>